/* eslint-disable max-len */
import 'react';

const ClearSearchInput = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id1 = `ClearSearchInput-1-${Date.now}`;
    const id2 = `ClearSearchInput-2-${Date.now}`;
    return (<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        <defs>
            <rect id={id1} x="0" y="0" width="10" height="10"></rect>
        </defs>
        <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="删除">
                <mask id={id2} fill="white">
                    <use xlinkHref={`#${id1}`}></use>
                </mask>
                <use id="矩形" fillOpacity="0" fill="#D8D8D8" xlinkHref={`#${id1}`}></use>
                <path d="M8.28337841,1.2123106 L8.8137085,1.74264069 C8.91133957,1.84027176 8.91133957,1.998563 8.8137085,2.09619408 L5.89697564,5.01297564 L8.8137085,7.92982502 C8.91133957,8.0274561 8.91133957,8.18574734 8.8137085,8.28337841 L8.28337841,8.8137085 C8.18574734,8.91133957 8.0274561,8.91133957 7.92982502,8.8137085 L5.01297564,5.89697564 L2.09619408,8.8137085 C1.998563,8.91133957 1.84027176,8.91133957 1.74264069,8.8137085 L1.2123106,8.28337841 C1.11467953,8.18574734 1.11467953,8.0274561 1.2123106,7.92982502 L4.12897564,5.01297564 L1.2123106,2.09619408 C1.11467953,1.998563 1.11467953,1.84027176 1.2123106,1.74264069 L1.74264069,1.2123106 C1.84027176,1.11467953 1.998563,1.11467953 2.09619408,1.2123106 L5.01297564,4.12897564 L7.92982502,1.2123106 C8.0274561,1.11467953 8.18574734,1.11467953 8.28337841,1.2123106 Z" id="形状结合" fill="#878D99" mask={`url(#${id2})`}></path>
            </g>
        </g>
    </svg>
    );
};
export default ClearSearchInput;
